var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggle1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 45",
    width: 40,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    x: 0,
    y: 0,
    width: 90,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#background"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-light",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8bc8f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur-light"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-light",
    width: 0.1,
    height: 1,
    viewBox: "0 0 10 45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40b5f8",
    d: "M 0 0 a 6 6 0 0 0 10 0 v 45 h -10 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-dark",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2241",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D59DF",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-mask",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-dark"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#gradient-mask)",
    href: "#background"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-moon"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfdfd",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e2e2",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-crater"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e0e0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9d9d9",
    offset: 1
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-dark",
    width: 0.2,
    height: 1,
    viewBox: "0 0 20 45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 2 5 l 1 1 l -1 1 l -1 -1 l 1 -1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 10 16 l 1 1 l -1 1 l -1 -1 l 1 -1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 16 27 l 1 1 l -1 1 l -1 -1 l 1 -1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 10 38 l 1 1 l -1 1 l -1 -1 l 1 -1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "dark"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#gradient-dark)",
    href: "#background"
  }), /*#__PURE__*/React.createElement("g", {
    className: "background",
    transform: "translate(0 -40) scale(1 0.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(-40 0) rotate(4)",
    fill: "url(#pattern-dark)",
    x: 0,
    y: 0,
    width: 100,
    height: 45
  })), /*#__PURE__*/React.createElement("use", {
    mask: "url(#mask-dark)",
    fill: "url(#gradient-dark)",
    href: "#background"
  })), /*#__PURE__*/React.createElement("g", {
    className: "light"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#gradient-light)",
    href: "#background"
  }), /*#__PURE__*/React.createElement("g", {
    className: "background",
    transform: "translate(-30 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#pattern-light)",
    x: -5,
    y: 27.5,
    width: 100,
    height: 45
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.5 22.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "translate",
    transform: "translate(-55)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "rotate",
    transform: "rotate(-100)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "dark"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#gradient-moon)",
    cx: 0,
    cy: 0,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -7.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-30)",
    fill: "url(#gradient-crater)",
    stroke: "#d5d5d5",
    strokeWidth: 0.2,
    cx: 0,
    cy: 0,
    rx: 4,
    ry: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#gradient-crater)",
    stroke: "#d5d5d5",
    strokeWidth: 0.2,
    cx: 0,
    cy: 0,
    rx: 3.85,
    ry: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 12)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-10)",
    fill: "url(#gradient-crater)",
    stroke: "#d5d5d5",
    strokeWidth: 0.2,
    cx: 0,
    cy: 0,
    rx: 2,
    ry: 1.75
  })))), /*#__PURE__*/React.createElement("g", {
    className: "light"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD21F",
    cx: 0,
    cy: 0,
    r: 21,
    filter: "url(#blur-light)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD21F",
    cx: 0,
    cy: 0,
    r: 20.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle1);
export default __webpack_public_path__ + "static/media/toggle1.a9e3c9ba32f7b6075959a191b6a40672.svg";
export { ForwardRef as ReactComponent };